import {apiClient, otpClient} from './ApiClient'
import {notify} from '../components/utils';


const tokenInfo = JSON.parse(sessionStorage.getItem("persist:root"));

if(tokenInfo) {
    const token = JSON.parse(tokenInfo.Token).token
    if(token) {
        apiClient.defaults.headers.Authorization = 'Bearer ' + token
    }
}

apiClient.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if ( error?.response?.status == 401) {


        notify("نشست شما منقضی شده است لطفا دوباره وارد شوید");
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;


    } else {
        return Promise.reject(error);
    }
});

export const getServiceInfo = () => otpClient.get("/client/transaction/V2/get-service-info");

export const sendOtp = (firstInfo) => otpClient.post("/client/transaction/V2/send-otp", firstInfo);

export const verifyOtp = (otpInfo) => otpClient.post("/client/transaction/V2/verify-otp", otpInfo);

export const acceptRule = (transaction_id) => apiClient.post(`/client/transaction/V2/accept-terms/${transaction_id}`)

export const payment = (transaction_id) => apiClient.post(`/client/transaction/V2/pay/${transaction_id}`)

export const getStatus = (transaction_id) => apiClient.get(`/client/transaction/V2/status/${transaction_id}`)

export const getUserInfo = () => apiClient.get("/client/transaction/V2/userinfo")

export const sendUserInfo = (transaction_id, userInfo) => apiClient.post(`/client/transaction/V2/complete-userinfo/${transaction_id}`,userInfo )

export const sendCsr = (transaction_id, csr) => apiClient.post(`/client/transaction/V2/issue-cert/${transaction_id}`,csr )

export const getcaptcha = (transaction_id) => apiClient.get(`/client/transaction/V2/get-captcha/${transaction_id}` )

export const sendEkyc = (transaction_id, videoData) => apiClient.post(`/client/transaction/V2/match-ekyc/${transaction_id}`,videoData )

export const newCertificate = (transaction_id) => apiClient.post(`/client/transaction/V2/revoke/${transaction_id}`)

export const getCertification = (transaction_id) => apiClient.get(`/client/transaction/V2/certificate/${transaction_id}` )

export const fillInfo = (formData) => apiClient.post(`/client/transaction/V2/fill-info`, formData)

export const checkInfoStatus = () => apiClient.get("/client/transaction/V2/check-info/status")

export const sendSmsForLognTerm = (transaction_id, status) => apiClient.post(`/client/transaction/V2/send-sms-for-long-term/${transaction_id}/${status}`)

export const adminLogin = (adminData) => apiClient.post(`/client/transaction/V2/verify-admin`, adminData)

export const updateService = (serviceData) => apiClient.post('/client/transaction/V2/update-service-info', serviceData)

export const companyInfoComplete = (transaction_id, companyData) => apiClient.post(`/client/transaction/V2/company_info/${transaction_id}`, companyData)

export const getCompanyInfo = (transaction_id) => apiClient.get(`/client/transaction/V2/company_info/${transaction_id}`)

export const newTransaction = (nationalId) => apiClient.post('/client/transaction/V2/new/transaction/company', nationalId);

export const cancelTransaction = (transaction_id, accountNumber) => apiClient.post(`/client/transaction/V2/cancel/${transaction_id}`, accountNumber );

export const getTransactionList = () => apiClient.get('/client/transaction/V2/transaction/list/company')

export const applyDiscountCode = (transaction_id,discount_code) => apiClient.post(`/client/transaction/V2/discount/${transaction_id}/${discount_code}` )

export const personalityRequest = () => apiClient.get('/leader/transaction/V2/personality/requests')

export const setCounselingPhoneNumber = (data) => apiClient.post('/client/transaction/V2/set/counseling/phone', data)